// extracted by mini-css-extract-plugin
export var button = "_j0-2";
export var card = "_j0-0";
export var closeButtonContainer = "_j0-3";
export var iconContainer = "_j0-1";